<template lang="pug">
  .profile-page-form
    achievement-modal(
      v-if="showAchievementModal"
      :default-award="defaultAward"
      @close="onCloseAchievementModal()"
      :title="achievementModalTitle"
      :read-only="true"
    )
    .profile-page-form__section-container
      section.profile-page-form__section.profile-section
        .profile-section__title
          h2.profile-section-title Общая информация
          label.checkbox(
            v-if="status === 2"
          )
            input.checkbox__input(
              type="checkbox"
              @change="onChangeAcceptValue($event, 'child_1')"
              :checked="acceptList.indexOf('child_1') > -1"
            )
            .checkbox__icon
        .profile-section__body
          info(
            :fields="dataProfile.main"
            :request-data="requestData"
          )
      section.profile-page-form__section.profile-section
        .profile-section__title
          h2.profile-section-title Адрес проживания
          label.checkbox(
            v-if="status === 2"
          )
            input.checkbox__input(
              type="checkbox"
              @change="onChangeAcceptValue($event, 'child_2')"
              :checked="acceptList.indexOf('child_2') > -1"
            )
            .checkbox__icon
        .profile-section__body
          info(
            :fields="dataProfile.address"
            :request-data="requestData.actual_address"
          )
      section.profile-page-form__section.profile-section
        .profile-section__title
          h2.profile-section-title Информация о школе
          label.checkbox(
            v-if="status === 2"
          )
            input.checkbox__input(
              type="checkbox"
              @change="onChangeAcceptValue($event, 'child_3')"
              :checked="acceptList.indexOf('child_3') > -1"
            )
            .checkbox__icon
        .profile-section__body
          info(
            :fields="dataProfile.school"
            :request-data="requestData.school_info"
          )
      section.profile-page-form__section.profile-section
        .profile-section__title
          h2.profile-section-title Портфолио
          label.checkbox(
            v-if="status === 2 && requestData.awards.length > 0"
          )
            input.checkbox__input(
              type="checkbox"
              @change="onChangeAcceptValue($event, 'child_4')"
              :checked="acceptList.indexOf('child_4') > -1"
              disabled
            )
            .checkbox__icon
        .profile-section__body
          awards(
            :status="status"
            :on-click-checkbox="onClickCheckbox"
            :current-awards-points="currentAwardsPoints"
            :fields="awards"
            :on-click-porfolio="clickPortfolio"
          )
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Документы
        label.checkbox(
          v-if="status === 2"
        )
          input.checkbox__input(
            type="checkbox"
            @change="onChangeAcceptValue($event, 'child_5')"
            :checked="acceptList.indexOf('child_5') > -1"
          )
          .checkbox__icon
      .profile-section__body
        info(
          :fields="dataProfile.docs[requestData.docType]"
          :request-data="requestData"
        )
</template>
<script>
import Info from "./Info";
import Awards from "./Awards";

import AchievementModal from "@/components/modals/AchievementModal";

export default {
  name: "InfoChild",
  components: {
    Awards,
    Info,
    AchievementModal
  },
  props: [
    "dataProfile",
    "requestData",
    "status",
    "onChangeAcceptValue",
    "acceptList",
    "awards",
    "onClickCheckbox",
    "currentAwardsPoints"
  ],
  data() {
    return {
      showErrorInfo: false,
      showAchievementModal: false,
      defaultAward: {},
      achievementModalTitle: "Достижение"
    };
  },
  methods: {
    onCloseAchievementModal() {
      this.showAchievementModal = false;
    },
    clickPortfolio(data) {
      this.defaultAward = data;
      this.showAchievementModal = true;
    }
  }
};
</script>
